
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/new-grad-jobs/rich/[new-grad-job-id]",
      function () {
        return require("private-next-pages/next/new-grad-jobs/rich/[new-grad-job-id].tsx");
      }
    ]);
  